import { render, staticRenderFns } from "./TheMovies.vue?vue&type=template&id=03203722&scoped=true&"
import script from "./TheMovies.vue?vue&type=script&lang=coffee&"
export * from "./TheMovies.vue?vue&type=script&lang=coffee&"
import style0 from "./TheMovies.vue?vue&type=style&index=0&id=03203722&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03203722",
  null
  
)

export default component.exports